import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateQuoteRequestLineMargins = ClientInferResponseBody<
  typeof contract.quoteRequestLines.updateMargins
>;

export type UpdateQuoteRequestLineMarginsDto = ClientInferRequest<
  typeof contract.quoteRequestLines.updateMargins
>["body"];

export const updateQuoteRequestLineMargins = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateQuoteRequestLineMarginsDto;
}): Promise<UpdateQuoteRequestLineMargins> => {
  const response = await api.quoteRequestLines.updateMargins.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update QuoteRequestLine margins", response.status, response.body);
};
